
<main class="container">
    <div class="row">
        <div class="center-block">
            
            <img class="center-block" alt="CellGate TrueCloud Logo" src="../../../assets//images/main-logo.png">
            <br>
            <hr style="margin-top: 0;">
            <div *ngIf="Iserrmessage">
            <img src="{{getImageSrc(ImageURL)}}" class="center-block responsive-img" (error)="downloaderror()"/>
            <br><br>
            
            <img class="center-block" src="https://user-staging.zapopen.com/public/images/DownloadImage.png" (click)="downloadImage()" alt="Download Image" />

            <hr>
            <p style="text-align: center;">
                Please note that this link will expire after closing. Download the image to retain access.
            </p>
            </div>
            <div *ngIf="!Iserrmessage">              
            <p style="text-align: center;">
                <br>
                <b style="font-size: 22px;">The image has expired.</b>
                <br><br>
                To view it again, please access it through your
                <br>
                TrueCloud Connect Access Management Platform.
            </p>
            <br>
                <img class="center-block" src="https://user-staging.zapopen.com/public/images/TrueCloudConnect.png" (click)="downloadUserportal()" alt="TrueCloudConnect" />
            </div>

        </div>
    </div>
</main>
